import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './styles/global.scss'
import { VueQueryPlugin } from '@tanstack/vue-query';
import App from './App.vue'
import router from '@/router/index'
import { useParentAuthStore } from '@/store/auth';

const app = createApp(App)
const vueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 1,
      },
    },
  },
};
app.use(createPinia());
app.use(VueQueryPlugin, vueQueryPluginOptions);
app.use(router);
const authStore = useParentAuthStore();
authStore.initialize().finally(() => {
  console.log('✅ Auth store initialized, mounting app...');
  app.mount('#app');
});